import React from 'react';
import css from '../../SlideoutEmail.module.css';
import { Chip } from '@mm/components';
import { nameById } from '@mm/state/helpers/filterable-select-helpers';
import AttributePicker from '../../../../../../../common/components/AttributePicker/AttributePicker';
import { CaretDownFilled } from '@ant-design/icons';
import { useView } from '../hooks/use-view';
import { insertText } from '../utils';

export interface AttributeProps {
  attributes: { id: number; name: string }[];
}

export const Attributes: React.FC<AttributeProps> = ({ attributes }) => {
  const view = useView();

  const insertBodyAttribute = (value: string) => {
    if (view?.state && view?.dispatch) {
      insertText(`{{${value}}}`, undefined)(view.state, view.dispatch);
      view.focus?.();
    }
  };

  return (
    <div className={css.attributes}>
      <span className={css.attributesTitle}>Insert attributes:</span>
      <div className={css.attributesList}>
        {attributes.slice(0, 5).map(attr => (
          <Chip
            key={attr.id}
            text={attr.name}
            type="info"
            onClick={() => {
              const name = nameById(attr.id, attributes, '', true);
              insertBodyAttribute(name);
              view?.focus?.();
            }}
            className={css.attribute}
          />
        ))}
        <AttributePicker
          className={css.picker}
          onAttributePicked={insertBodyAttribute}
        >
          <Chip type="info" text="Other" className={css.attribute}>
            <CaretDownFilled />
          </Chip>
        </AttributePicker>
      </div>
    </div>
  );
};
